import { GetterTree, MutationTree, ActionTree } from 'vuex'
import services from '@/services/index'
import { UserDataInterface } from './types/index'

const namespaced = true

class State {
  isAuthenticated = false
  userCountryISO: null | string = null
  isLoaded = false
  userData = <UserDataInterface>{
    profiles: [],
    email: '',
    first_name: '',
    last_name: '',
    patronymic: '',
    phone: '',
    promo: '',
    pk: 0,
    account_id: '',
    visitor_hash: null,
    uuid: '',
    nickname: '',
    discord_nickname: '',
    telegram_nickname: '',
    currentAccessRepairMethods: [],
    verificationRights: {
      currentLevelMonthLimit: null,
      currentRecovery: null,
      isNewUser: true,
      levelName: ''
    }
  }
}

const getters = <GetterTree<State, any>> {
  getIsAuthenticated: state => state.isAuthenticated,
  getUserCountryISO: (state: any) => state.userCountryISO,
  getUserData: state => state.userData,
  getIsLoaded: state => state.isLoaded,
  getIsActiveMainProfile: state => {
    const activeProfile = state.userData.profiles.find((profile) => profile.status === 'active')
    return activeProfile && activeProfile.main
  }
}

const actions = <ActionTree<State, any>> {
  async loadUser ({ commit }): Promise<void> {
    commit('setLoaded', false)
    // @ts-ignore
    const response = await services.authorization.user.loadUser(null)
    // @ts-ignore
    if (response.success) {
      // @ts-ignore
      commit('setUserData', response.data)
      commit('setIsAuthenticated', true)
    }
    commit('setLoaded', true)
  },
  async getUserProfiles ({ commit }) {
    // @ts-ignore
    const response = await services.authorization.user.getUserProfiles()
    // @ts-ignore
    if (response.success && response.data?.profiles.list) {
      // @ts-ignore
      commit('setProfileList', response.data.profiles.list)
    }
  }
}

const mutations = <MutationTree<State>> {
  setIsAuthenticated (state, payload: boolean) { state.isAuthenticated = payload },
  setUserCountryISO (state, payload: string) { state.userCountryISO = payload },
  setUserData (state, payload: UserDataInterface) {
    state.userData = {
      ...state.userData,
      ...payload
    }
  },
  setUserNickname (state, payload: string) {
    state.userData.nickname = payload
  },
  setCurrentAccessRepairMethods (state: any, payload: Array<string>) {
    state.userData.currentAccessRepairMethods = payload
  },
  setLoaded (state, payload: boolean) { state.isLoaded = payload },
  setProfileList (state, payload) {
    state.userData.profiles = payload
  },
  updateProfileList (state, { userId, name }) {
    state.userData.profiles.forEach((profile) => {
      if (profile.id === userId) profile.name = name
    })
  },
  changeActiveUser (state, { userId }) {
    state.userData.profiles.forEach((profile) => {
      profile.status = profile.id === userId ? 'active' : 'success'
    })
  }
}

export default {
  namespaced,
  state: new State(),
  actions,
  getters,
  mutations
}
